import React, { useState } from "react";
import { string, func, number, array, object, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./keyHighlights.m.css";

const goToCard = cardId => {
  if (cardId) {
    setTimeout(function() {
      document.getElementById(cardId) &&
        document.getElementById(cardId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
    }, 100);
  }
};

const KeyHighlights = ({ keyHighlights, publisherAttributes, stickyHighlights }) => {
  const [indexValue, setIndexValue] = useState(null);
  const scrollEvent = (id, index) => {
    goToCard(id);
    if (index !== indexValue) {
      setIndexValue(index);
    }
  };

  return (
    <div styleName="wrapper" className={`key-highlights ${stickyHighlights ? "sticky-highlights" : ""}`}>
      <ul styleName="list" className="key-highlights-list">
        {keyHighlights.map((highlight, index) => {
          const cardName = index === 0 || index === keyHighlights.length - 1 ? "dash" : "circle";

          return (
            <KeyHighlight
              key={`highlight-${highlight.card.id}`}
              highlight={highlight}
              cardName={cardName}
              onClick={() => scrollEvent(highlight.card.id, index)}
              index={index}
              indexValue={indexValue}
              publisherAttributes={publisherAttributes}
            />
          );
        })}
      </ul>
    </div>
  );
};

const KeyHighlight = ({ highlight, cardName, onClick, index, indexValue, publisherAttributes }) => (
  <li styleName="key" onClick={onClick}>
    <span styleName={`${cardName} ${index === indexValue ? "active" : ""}`} />
    <time styleName={`time ${publisherAttributes.lang === "en" ? "en-time" : ""}`}>
      {new Date(highlight.card["card-added-at"]).toLocaleTimeString(publisherAttributes.lang === "en" ? "en" : "bn-BN")}
    </time>
    <div styleName="text">{highlight.title}</div>
  </li>
);

KeyHighlights.propTypes = {
  keyHighlights: array,
  stickyHighlights: bool,
  publisherAttributes: object
};

const mapStateToProps = state => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

KeyHighlight.propTypes = {
  highlight: object,
  cardName: string,
  onClick: func,
  index: number,
  indexValue: number,
  publisherAttributes: object
};

export default connect(mapStateToProps, null)(KeyHighlights);
